export const helpText = {
  companies: "This is a count of the number of Companies in which the detected plays have been played on any channel e.g. On the Radio.",
  plays:
    "A Play is when a Track is detected as having been played on any channel e.g. On the Radio. If the same track is detected twice, then this will be a count of 2 Plays.",
  tracks:
    "This is a count of the number of unique songs (Tracks) detected as having been played on any channel e.g. On the Radio.",
  artists:
    "This is a count for the number of unique artist, whose tracks have been detected as having been played on any channel e.g. On the Radio.",
  radioStation:
    "This is a count of the number of Radio Stations on which the detected plays have been played.",
  countries:
    "This is a count of the number of Countries in which the detected plays have been played on any channel e.g. On the Radio.",
};
